import React from 'react';
import { t } from '../../services/locale';
import type { ProfileDocumentRow } from './profileAccount.types';

export type ProfileDocumentsListData = {
  documents?: ProfileDocumentRow[];
  onPreviewStudioWaiver?: () => void;
  onOpenDocument?: (document: ProfileDocumentRow) => void;
};

type Props = Readonly<{
  data?: ProfileDocumentsListData;
}>;

function decodeAmpersand(value: string): string {
  return value.replace(/&amp;/g, '&');
}

function documentLabel(name: string): string {
  return decodeAmpersand(t(name));
}

function DocumentRow({
  document,
  onOpenDocument,
}: Readonly<{
  document: ProfileDocumentRow;
  onOpenDocument?: (document: ProfileDocumentRow) => void;
}>) {
  return (
    <li className="border-top">
      <div className="list-text-left">
        <a
          href="#"
          onClick={(event) => {
            event.preventDefault();
            onOpenDocument?.(document);
          }}
        >
          {documentLabel(document.name)}
        </a>
        {document.signed ? (
          <p className="date">{document.signedDate}</p>
        ) : (
          <p className="date">{t('WEB_NOT_SIGNED')}</p>
        )}
      </div>
      {document.signed ? (
        <p className="add-card icon-success icon-confirmation" />
      ) : (
        <p className="add-card icon-error icon-circled-x" />
      )}
    </li>
  );
}

export function ProfileDocumentsList({ data }: Props) {
  if (!data) {
    return null;
  }

  const documents = data.documents ?? [];

  return (
    <ul className="list cards">
      <li className="noBorder">
        <div
          role="button"
          tabIndex={0}
          onClick={() => data.onPreviewStudioWaiver?.()}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              data.onPreviewStudioWaiver?.();
            }
          }}
        >
          <p className="smaller center">{decodeAmpersand(t('WEB_PREVIEW_STUDIO_WAIVER'))}</p>
        </div>
      </li>
      {documents.map((document, index) => (
        <DocumentRow
          key={`${document.documentUrl}-${index}`}
          document={document}
          onOpenDocument={data.onOpenDocument}
        />
      ))}
    </ul>
  );
}
